import { render, staticRenderFns } from "./JointClientFormInput.vue?vue&type=template&id=5990a7a6&scoped=true"
import script from "./JointClientFormInput.vue?vue&type=script&lang=js"
export * from "./JointClientFormInput.vue?vue&type=script&lang=js"
import style0 from "./JointClientFormInput.vue?vue&type=style&index=0&id=5990a7a6&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5990a7a6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/tmp/build_997aa59e/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5990a7a6')) {
      api.createRecord('5990a7a6', component.options)
    } else {
      api.reload('5990a7a6', component.options)
    }
    module.hot.accept("./JointClientFormInput.vue?vue&type=template&id=5990a7a6&scoped=true", function () {
      api.rerender('5990a7a6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/clientForms/client-agreement/JointClientFormInput.vue"
export default component.exports